import React, { useEffect, useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataImmo } from '../../../data/modules/logistic-header';
import { Box, Button, Chip, Grid, Paper, TableRow, TextField, IconButton} from '@mui/material';
import { TableCell, TableContainer, Table, TableBody, makeStyles  } from '@material-ui/core';
import ProvisionalFuelMissionService from '../../../services/ProvisionalFuelMissionService';
import { useNavigate, useParams } from 'react-router';
import MissionTransportService from '../../../services/MissionTransportService';
import Title from '../../../components/Title';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import TimeToLeaveIcon from "@mui/icons-material/TimeToLeave";
import CardTravelIcon from "@mui/icons-material/CardTravel";
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import Message from '../../tools/Message';
import SaveIcon from '@mui/icons-material/Save';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px !important",
    marginTop: "1.5%",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
    width: "100%",
  },
  tab: {
    minWidth: "400px !important",
    fontSize: "0.8rem",
  },
  AppBar: {
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  },
  box: {
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    borderRadius: "8px !important",
    maxWidth: "156vh",
    minWidth: "100vh",
  },
}));

const TimesheetVehicle = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    let missionId = id ? parseInt(id) : 0;
    let transportId = 0;
    const classes = useStyles();
    const [transportData, setTransportData] = useState([]);
    const [rows, setRows] = useState([]);
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });
    const { open, color, messageInfo } = message;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
    
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
    
        return `${day}/${month}/${year}`;
      };

       function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

      const fetchData = async () => {
            setOpenLoadingSimpleBackdrop(true);
            setTransportData({});
            try {
                const transports = await MissionTransportService.transportsByMissionPlanning(missionId);
                if (transports.status && transports.data) {

                    for (const transport of transports.data) {
                const missions = await MissionTransportService.missionsByTranport(transport.transport_id);
                transport.missions = missions.data || [];
                const timesheetId = transport.mission_timesheet_id || 0;
                const transportId = transport.transport_id || 0;
                const response = await ProvisionalFuelMissionService.getTimesheetVehicleDetails(transportId, timesheetId);
                if (response.status && response.data) {
                        console.log("response", response.data);
                    const data = response.data.map((item, index) => ({
                        ...item,
                        id: index + 1,
                    }));
                  
                    setRows({ ...rows, [transportId]: data });
                    setOpenLoadingSimpleBackdrop(false);
                } else {
                    setMessage({
                        open: true,
                        color: 'red',
                        messageInfo: response.message || 'Failed to fetch timesheet data',
                    });
                    setOpenLoadingSimpleBackdrop(false);
                }
            } }
                setTransportData(transports.data);
            } catch (error) {
                console.error('Error fetching timesheet data:', error);
            }
        };

    useEffect(() => {
        fetchData();
    }, []);
console.log("transport", transportData);
    const handleDownloadTimesheet = async (transportId, missionTimesheetId) => {
            try {
                const response = await ProvisionalFuelMissionService.generateTimesheetVehicle(transportId, missionTimesheetId);
                if (response.status) {
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `timesheet_${transportId}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    setMessage({
                        open: true,
                        color: 'red',
                        messageInfo: response.message || 'Erreur lors du téléchargement du timesheet.',
                    });
                }
            } catch (error) {
                console.error('Error downloading timesheet:', error);
                setMessage({
                    open: true,
                    color: 'red',
                    messageInfo: 'Erreur lors du téléchargement du timesheet.',
                });
            }
        };
    
    const handleInit = () => {
      fetchData();
      setMessage({
        open: true,
        color: 'green',
        messageInfo: 'Timesheet réinitialisé avec succès',
      });
    };      

    const handleChangeKm = (e, id, index) => {
        const newRows = rows[index].map((row) => {
            if (row.id === id) {
                return { ...row, mission_timesheet_details_km: e.target.value };
            }
            return row;
        });
        setRows({ ...rows, [index]: newRows });
    }

    const prepareDataToSave = () => {
      const dataTosave = {
        state: "CONFIRMED",
        transport_id: transportId,
        agendas: rows.map((row) => ({
          mission_planning_agenda_id : row.mission_agenda_id,
          fuel_price_id : transportData.fuel_price_id,
        })),
        timesheet: rows.map((row) => ({
          destination_id: row.mission_destination_id,
          mission_timesheet_details_km: row.mission_timesheet_details_km,
          transport_id: transportId,
            mission_timesheet_details_amount: ((row.mission_timesheet_details_km * transportData.vhc_conso_100km * transportData.price_per_liter) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          mission_timesheet_fuel_id: transportData.mission_timesheet_id ? row.mission_timesheet_fuel_id : 0,
      })),
      }
        
      return dataTosave;
    }
console.log('transportsData', transportData);
    const handleSave = async () => {
      
        console.log('rows', rows);
        for (const transport of transportData) {
            if (!rows[transport.transport_id] || rows[transport.transport_id].length === 0) {
                setMessage({
                    open: true,
                    color: 'red',
                    messageInfo: `Aucune donnée à enregistrer pour le véhicule ${transport.vhc_imm}`,
                });
                return;
            }

            let row = rows[transport.transport_id];
        const isValid = row.every(r => r.mission_timesheet_details_km !== undefined && r.mission_timesheet_details_km !== '');
         if (!isValid) {
            setMessage({
                open: true,
                color: 'red',
                messageInfo: 'Veuillez remplir tous les champs de kilométrage',
            });
            return;
        }
             try {
            const dataToSave = prepareDataToSave(row);
            const response = await ProvisionalFuelMissionService.saveTimeSheetMission(dataToSave);
            if (response.status) {
               
                handleDownloadTimesheet(transportId, response.mission_timesheet_id);
               
            } else {
                setMessage({
                    open: true,
                    color: 'red',
                    messageInfo: response.message || 'Echec de l\'enregistrement des données du prévision de carburant',
                });
            }
        } catch (error) {
            console.error('Error saving timesheet data:', error);
            setMessage({
                open: true,
                color: 'red',
                messageInfo: 'Une erreur est survenue lors de l\'enregistrement des données du prévision de carburant',
            });
        }

        }
         setMessage({
                    open: true,
                    color: 'green',
                    messageInfo: 'Prévision enregistré avec succès',
                });
         navigate('/logistic/mission/timesheet');
       
    }

    return (
        <MainContainer {...headerDataImmo}>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
                <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} /> 
        <Grid container spacing={2}>
            <Grid item xs={12} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <Title>Décompte prévisionnel de carburant</Title>
                 <Button variant="outlined" color="primary" onClick={() => handleInit()} startIcon={<RefreshIcon/>} style={{ marginRight: "30px" }}>
                      Réinitialiser
                    </Button>
                </Grid>
            {
               transportData.length > 0 && transportData?.map((transport, index) => (
             <Grid container key={index} >
                      <fieldset style={{  borderRadius: "10px", width: "100%", marginBottom: "20px", padding: "20px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px" }}>
                        <legend style={{
                          color: "#1976d2",
                          fontSize: "24px",
                        }}>&nbsp;&nbsp;
                          {` ${transport.vhc_imm} - ${transport.vhc_type}`}
                          &nbsp; &nbsp;
                        </legend>
            <Grid container spacing={2} item xs={12}>
            <Grid item xs={12} md={4} lg={4} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <label>Direction voiture : <strong>{transport.direction_code}</strong></label>
                <label>Chauffeur : <strong>{transport.driver_name}</strong></label> <br></br>
                <label>Consommation à 100 km : <strong>{transport.vhc_conso_100km}</strong> litre(s)</label>

            </Grid>
            <Grid item xs={12} md={4} lg={4} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
               <label>Missions :</label>
               
                   {transport.missions.map((mission, index) => (
                       <li key={index}><strong>{mission.reference} </strong>  du {mission.date_begin} au {mission.date_end} ( {mission.lieu} )</li>
                   ))}
             
            </Grid>
            <Grid item xs={12} md={4} lg={4} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
               <label>Missionnaire(s) :</label>
               
                   {transport.missionnaries.map((missionnaire, index) => (
                       <li key={index}><strong>{missionnaire.nom} </strong> </li>
                   ))}
             
            </Grid>
            </Grid>
            <Paper style={{ padding: '20px', marginBottom: '20px', marginTop: '20px', borderRadius: '8px', boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px' }} className={classes.paper}>
        <Grid container spacing={2}>
          <TableContainer style={{ width: '100%' }}>
            <Table>
                
                <TableRow>
                    <TableCell><strong>Date</strong></TableCell>
                    <TableCell><strong>Type</strong></TableCell>
                    <TableCell><strong>Lieu de départ</strong></TableCell>
                    <TableCell><strong>Lieu d'arrivée</strong></TableCell>
                    <TableCell><strong>Kilometrage (KM)</strong></TableCell>
                    <TableCell><strong>Consommation (L)</strong></TableCell>
                    <TableCell><strong>Montant (Ar)</strong></TableCell>
                    <TableCell><strong>Action</strong></TableCell>
                </TableRow>
                <TableBody>
                    {rows[transport.transport_id]?.map((row) => (
                        <TableRow key={row.id}>
                            <TableCell> <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                { formatDate(row.date_begin)} { row.date_begin != row.date_end ? "-" + formatDate(row.date_end) : ""}
                                </label></TableCell>
                            <TableCell> {row.type === "DM" ? (
                                          <Chip
                                            icon={<CardTravelIcon />}
                                            label="Mission"
                                            variant="outlined"
                                            color="info"
                                          />
                                        ) : (
                                          <Chip
                                            icon={<TimeToLeaveIcon />}
                                            label="Délai de route"
                                            variant="outlined"
                                            color="info"
                                          />
                                        )}
                                </TableCell>
                            <TableCell> <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {row.type === "DR"
                                            ? `${row.depart}`
                                            : row.activite === "mis"
                                            ? row.district
                                            : row.direction_location + "(" + row.direction_code + ")"}
                                        </label></TableCell>
                            <TableCell><label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {row.type === "DR"
                                            ? `${row.arriver}`
                                            : row.activite === "mis"
                                            ? row.district
                                            : row.direction_location + "(" + row.direction_code + ")"}
                                        </label></TableCell>
                            <TableCell> <TextField 
                                type="number"
                                value={row.mission_timesheet_details_km}
                                onChange={(e) => handleChangeKm(e, row.id, transport.transport_id)}
                                variant="outlined"
                                size="small"
                                label = "km"
                                style={{ width: '100px' }}
                            /> 
                                {/* {row.mission_timesheet_details_km} km */}
                                </TableCell>
                            <TableCell>{(row.mission_timesheet_details_km * transport.vhc_conso_100km) / 100 }</TableCell>
                            <TableCell style={{ backgroundColor: '#e6f9ff' }}> 
                                <strong>{((row.mission_timesheet_details_km * transport.vhc_conso_100km * transport.price_per_liter) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></TableCell>
                            <TableCell>
                                <IconButton color="error" onClick={() => {
                                    const newRows = { ...rows };
                                    newRows[transport.transport_id] = newRows[transport.transport_id].filter(r => r.id !== row.id);
                                    setRows(newRows);

                                    setMessage({open: true, color: 'green', messageInfo: 'Ligne supprimée avec succès'});
                                }}>
                                            <CloseIcon/>
                                </IconButton>
                                </TableCell>
                        </TableRow>
                    ))}
                    <TableRow style={{ backgroundColor: '#e6f9ff' }}>
                        <TableCell colSpan={4} style={{ textAlign: 'right' }}>
                            <strong>Total :</strong>
                        </TableCell>
                        <TableCell>
                        <strong>
                        {rows[transport.transport_id]?.reduce((acc, row) => acc + Number(row.mission_timesheet_details_km || 0), 0)
                            .toLocaleString('fr-FR')} km
                        </strong>
                            </TableCell>
                        <TableCell>
                            <strong>
                                {(
                                    rows[transport.transport_id]?.reduce((acc, row) => acc + Number(row.mission_timesheet_details_km || 0), 0) 
                                    * transport.vhc_conso_100km / 100
                                ).toLocaleString('fr-FR', { minimumFractionDigits: 0 })} L
                                </strong>
                        </TableCell>
                        <TableCell>
                            <strong>
                            {(
                                rows[transport.transport_id]?.reduce((acc, row) => acc + Number(row.mission_timesheet_details_km || 0), 0) 
                                * transport.vhc_conso_100km 
                                * transport.price_per_liter / 100
                            ).toLocaleString('fr-FR', { minimumFractionDigits: 0 })} Ar
                            </strong>
                        </TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            </TableContainer>
            </Grid>
                </Paper>
                            </fieldset>
                            </Grid>
                            
            ))}
           <Grid item xs={12}
                display="flex" 
                justifyContent="flex-end" 
                sx={{ marginBottom: "20px" }}
            >
                <Button color="error" onClick={() => navigate('/logistic/mission/timesheet')} 
                style={{ marginRight: "30px" }} variant="contained"
                    >
                    Annuller
                    </Button>
                   
                <Button variant="contained" color="primary" onClick={() => handleSave()} startIcon={<SaveIcon/>} style={{ marginRight: "30px" }}>
                    Confirmer
                    </Button>
            </Grid>
        </Grid>
        </MainContainer>
    );
    }

export default TimesheetVehicle;